"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M4.656 6.434H.641a.323.323 0 0 0-.325.324v12.898c0 .176.145.32.325.32h4.015c.176 0 .32-.144.32-.32V6.758a.323.323 0 0 0-.32-.324ZM2.648.024A2.65 2.65 0 0 0 0 2.667a2.65 2.65 0 0 0 2.648 2.648 2.65 2.65 0 0 0 2.649-2.648A2.65 2.65 0 0 0 2.648.023Zm12.22 6.09c-1.614 0-2.806.695-3.528 1.48v-.836a.323.323 0 0 0-.32-.324H7.172a.323.323 0 0 0-.32.324v12.898c0 .176.144.32.32.32h4.008c.175 0 .32-.144.32-.32v-6.383c0-2.152.586-2.988 2.086-2.988 1.633 0 1.762 1.344 1.762 3.098v6.273c0 .176.144.32.32.32h4.008c.18 0 .324-.144.324-.32v-7.074c0-3.2-.61-6.469-5.133-6.469Zm0 0"
}), 'LinkedIn', {
  viewBox: '0 0 20 24'
});

exports.default = _default;